import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ngForFadeInOpacity, ngForFadeInOut } from 'src/app/animations';

@Component({
  selector: 'app-expandable-section-box',
  templateUrl: './expandable-section-box.component.html',
  styleUrls: ['./expandable-section-box.component.scss'],
  animations: [ngForFadeInOpacity, ngForFadeInOut],
})
export class ExpandableSectionBoxComponent implements OnInit {
  @Input() title = 'Section';
  @Input() iconClass: string;
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
  @Input() headerHeight: string = '43px';

  @ViewChild(MatExpansionPanel) matExpansionPanel: MatExpansionPanel;

  isExpanded = false;

  constructor() {}

  ngOnInit(): void {}

  onOpen(_): void {
    this.isExpanded = true;
  }

  onClose(_): void {
    this.isExpanded = false;
  }

  onAfterCollapse(_): void {
    this.isExpanded = false;
  }

  openPanel() {
    if (this.isExpandable) {
      this.matExpansionPanel.open();
    }
  }
}
